import type { FC } from 'react';
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from '@compat/router';
import { Picture } from '@ui';
import icons from '@icons';
import { when } from 'mobx';
import './index.scss';
import { useStores } from '@root/src/stores';

const {
  rotateCW: { black: rotateCWBlackOutlined, red: rotateCWRedOutlined }
} = icons.Outline;

const RepeatBtn: FC = observer(() => {
  const { userStore, cartStore } = useStores();
  const history = useHistory();
  const [isHovered, setIsHovered] = useState(false);

  const repeat = (): void => {
    if (!userStore.lastDeliveredOrderId) {
      return;
    }
    cartStore
      .repeatOrder(userStore.lastDeliveredOrderId, false)
      .then(() => {
        history.push('/cart');
      })
      .catch(err => {
        console.log('Error: ', err);
      });
  };

  useEffect(() => {
    when(
      () => userStore.isLoad && cartStore.isLoadCart,
      () => {
        const { search, pathname } = history.location;
        if (
          pathname === '/cart' &&
          search === '?repeat=latest' &&
          !!userStore.lastDeliveredOrderId
        ) {
          repeat();
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!userStore.isUserLoggedIn || !userStore.lastDeliveredOrderId) {
    return null;
  }
  return (
    <div
      className='repeat-wrapper'
      onMouseEnter={() => {
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        setIsHovered(false);
      }}
    >
      <div onClick={repeat} className='repeat-btn'>
        <Picture
          pictureClassName='repeat-btn__icon'
          icon={isHovered ? rotateCWRedOutlined.x2 : rotateCWBlackOutlined.x2}
          height='20'
          width='20'
        />
      </div>
      <div className='repeat-wrapper__tooltip'>
        Повторить последний доставленный заказ
      </div>
    </div>
  );
});

export default RepeatBtn;
